// 2026-10-10 perf:国家选择器点开才加载整张表。页面里的 <localization-form data-lazy-country="…"> 只有按钮;
// 第一次点(或悬停/触摸时预取)就用 Section Rendering API 取回完整表单,整块替换后再替用户点开。
(() => {
  if (window.__pdLazyCountry) return;
  window.__pdLazyCountry = true;
  const cache = new Map();
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const load = (section) => {
    if (!cache.has(section)) {
      cache.set(section, fetch(`${root}?section_id=${encodeURIComponent(section)}`, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .catch((e) => { cache.delete(section); throw e; }));
    }
    return cache.get(section);
  };
  const holderOf = (target) => target && target.closest && target.closest('localization-form[data-lazy-country]');
  // 2026-10-13 修:Section Rendering 取回的表单里 return_to = "/?section_id=…",切完国家会被送到那个半截地址。
  // 占位表单是在当前页渲染的,return_to 正确 → 换上新表单前抄过去;占位没有时退回当前地址(去掉 section_id)。
  const currentPath = () => {
    const params = new URLSearchParams(location.search);
    params.delete('section_id');
    const qs = params.toString();
    return location.pathname + (qs ? `?${qs}` : '');
  };
  const fixReturnTo = (holder, node) => {
    const keep = holder.querySelector('input[name="return_to"]');
    const value = keep && keep.value && !/section_id=/.test(keep.value) ? keep.value : currentPath();
    const form = node.querySelector('form');
    if (!form) return;
    let input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = value;
  };
  const swap = async (holder, open) => {
    const section = holder.dataset.lazyCountry;
    if (holder.dataset.lazyBusy) return;
    holder.dataset.lazyBusy = '1';
    try {
      const tpl = document.createElement('template');
      tpl.innerHTML = await load(section);
      const fresh = tpl.content.querySelector('localization-form');
      if (!fresh || !holder.isConnected) return;
      const node = document.importNode(fresh, true);
      fixReturnTo(holder, node);
      holder.replaceWith(node);
      const button = node.querySelector('button.localization-form__select');
      if (open && button) { button.focus(); button.click(); }
    } catch (e) {
      delete holder.dataset.lazyBusy;
    }
  };
  // 捕获阶段拦截:旧占位组件的空面板永远不会被打开
  document.addEventListener('click', (event) => {
    const holder = holderOf(event.target);
    if (!holder || !event.target.closest('button.localization-form__select')) return;
    event.preventDefault();
    event.stopPropagation();
    swap(holder, true);
  }, true);
  const prefetch = (event) => {
    const holder = holderOf(event.target);
    if (holder) load(holder.dataset.lazyCountry).catch(() => {});
  };
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
})();
